// AB#2130 — extracted verbatim from pages/TenantDetail.tsx as part of the tenant-detail layout-route split.

// ---- Status badge ----

export function StatusBadge({ status }: { status: string }) {
    const colours: Record<string, string> = {
        Active: 'bg-green-100 text-green-800',
        Suspended: 'bg-yellow-100 text-yellow-800',
        PendingBootstrap: 'bg-blue-100 text-blue-800',
        Archived: 'bg-neutral-100 text-neutral-600',
    }
    const cls = colours[status] ?? 'bg-neutral-100 text-neutral-600'
    return (
        <span className={`inline-flex px-2 py-0.5 rounded text-xs font-medium ${cls}`}>
            {status}
        </span>
    )
}
